import Seo from "@/components/site/Seo";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/motion";
import { FAQList, CTABanner } from "@/components/site/Blocks";
import { services } from "@/data/services";
import { generalFaqs } from "@/data/content";

const groups = [{ name: "General", faqs: generalFaqs }, ...services.map((s) => ({ name: s.name, faqs: s.faqs }))];

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: groups.flatMap((g) => g.faqs).map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
};

export default function FAQPage() {
  return (
    <>
      <Seo title="Frequently Asked Questions" description="Clear answers about visitor visas, work permits, permanent residence, residence and citizenship by investment, and how Immistop works." jsonLd={jsonLd} />
      <PageHero compact eyebrow="FAQ" lines={["Questions,", <em key="e" className="italic text-gold">answered plainly.</em>]} image="/img/auckland.jpg" testid="faq-hero" />
      <section className="section-lux bg-ivory" data-testid="faq-groups">
        <div className="container-lux grid gap-12 lg:grid-cols-[260px_1fr]">
          <nav className="hidden lg:sticky lg:top-32 lg:block lg:self-start" aria-label="FAQ sections">
            <ul className="space-y-3">
              {groups.map((g, i) => <li key={g.name}><a href={`#faq-${i}`} className="text-[13px] font-semibold uppercase tracking-[0.18em] text-charcoal-soft hover:text-gold-deep">{g.name}</a></li>)}
            </ul>
          </nav>
          <div className="space-y-20">
            {groups.map((g, i) => (
              <div key={g.name} id={`faq-${i}`} className="scroll-mt-32">
                <Reveal><h2 className="mb-6 font-serif text-4xl text-navy md:text-5xl">{g.name}</h2></Reveal>
                <FAQList items={g.faqs} prefix={`faq-${i}`} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTABanner title="Still have a question?" text="Our advisers are happy to help. Arrange a private, confidential conversation at a time that suits you." />
    </>
  );
}
